// Strips out html tags and html entities from a string. We use it for the FAQs coming from contentful as HTML.
export const stripHTML = (html: string) => {
  try {
    let rawText = html.replace(/<[^>]+>/g, ' ');
    rawText = rawText.replace(/&nbsp;/g, ' ');
    rawText = rawText.replace(/&[^;]+;/g, '');
    rawText = rawText.replace(/\n/g, ' ').trim();
    rawText = rawText.replace(/\s+/g, ' ').trim();
    return rawText;
  } catch (_) {
    return html;
  }
};
